import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=0c7688e4&scoped=true&"
import script from "./DesktopHeader.vue?vue&type=script&lang=js&"
export * from "./DesktopHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=0c7688e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7688e4",
  null
  
)

export default component.exports